var _path, _path2, _path3, _path4, _circle, _path5, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 218,
    viewBox: "0 0 152 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.702 145.56C111.808 145.56 102.131 135.883 102.131 123.989C102.131 120.352 99.1823 117.403 95.545 117.403C91.9077 117.403 88.9589 120.352 88.9589 123.989C88.9589 135.884 79.2816 145.56 67.3879 145.56C63.7506 145.56 60.8018 148.509 60.8018 152.146C60.8018 155.783 63.7506 158.732 67.3879 158.732C79.2825 158.732 88.9589 168.409 88.9589 180.303C88.9589 183.94 91.9077 186.889 95.545 186.889C99.1823 186.889 102.131 183.94 102.131 180.303C102.131 168.409 111.808 158.732 123.702 158.732C127.339 158.732 130.288 155.783 130.288 152.146C130.288 148.509 127.339 145.56 123.702 145.56ZM95.5441 159.97C93.3681 156.966 90.7239 154.321 87.7189 152.146C90.7239 149.97 93.3681 147.326 95.5441 144.322C97.7202 147.326 100.364 149.971 103.369 152.146C100.364 154.322 97.7202 156.966 95.5441 159.97Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2724 58.7001C68.3778 58.7001 58.7015 49.0228 58.7015 37.1291C58.7015 33.4918 55.7526 30.543 52.1153 30.543C48.478 30.543 45.5292 33.4918 45.5292 37.1291C45.5292 49.0237 35.8519 58.7001 23.9582 58.7001C20.3209 58.7001 17.3721 61.6489 17.3721 65.2862C17.3721 68.9235 20.3209 71.8724 23.9582 71.8724C35.8528 71.8724 45.5292 81.5496 45.5292 93.4433C45.5292 97.0806 48.478 100.029 52.1153 100.029C55.7526 100.029 58.7015 97.0806 58.7015 93.4433C58.7015 81.5487 68.3787 71.8724 80.2724 71.8724C83.9097 71.8724 86.8586 68.9235 86.8586 65.2862C86.8586 61.6489 83.9097 58.7001 80.2724 58.7001ZM52.1144 73.1106C49.9384 70.1064 47.2943 67.4614 44.2892 65.2862C47.2943 63.1102 49.9384 60.466 52.1144 57.4619C54.2905 60.466 56.9346 63.111 59.9397 65.2862C56.9346 67.4623 54.2905 70.1064 52.1144 73.1106Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.155 10.4987H141.644V4.98759C141.644 2.31212 139.475 0.143066 136.8 0.143066C134.124 0.143066 131.955 2.31212 131.955 4.98759V10.4987H126.444C123.769 10.4987 121.6 12.6678 121.6 15.3432C121.6 18.0187 123.769 20.1878 126.444 20.1878H131.955V25.6989C131.955 28.3744 134.124 30.5434 136.8 30.5434C139.475 30.5434 141.644 28.3744 141.644 25.6989V20.1878H147.155C149.831 20.1878 152 18.0187 152 15.3432C152 12.6678 149.831 10.4987 147.155 10.4987Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5558 197.241H20.0447V191.73C20.0447 189.054 17.8757 186.885 15.2002 186.885C12.5247 186.885 10.3557 189.054 10.3557 191.73V197.241H4.84452C2.16905 197.241 0 199.41 0 202.085C0 204.761 2.16905 206.93 4.84452 206.93H10.3557V212.441C10.3557 215.117 12.5247 217.286 15.2002 217.286C17.8757 217.286 20.0447 215.117 20.0447 212.441V206.93H25.5558C28.2313 206.93 30.4003 204.761 30.4003 202.085C30.4003 199.41 28.2313 197.241 25.5558 197.241Z",
    fill: "#F1F1F1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3215,
    cy: 108.424,
    r: 28.4235,
    fill: "#FF3465"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4199 106.655L75.7816 102.293M75.7816 102.293L80.1433 106.655M75.7816 102.293L75.7816 115.669",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 127.5,
    r: 2.5,
    stroke: "#FF3465",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.5,
    cy: 76.5,
    r: 2.5,
    stroke: "#FF3465",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 186.5,
    r: 2.5,
    stroke: "#FF3465",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.04ceafba6aae027d8ab53ccdd56d18a9.svg";
export { ForwardRef as ReactComponent };